<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from 'ant-design-vue';

type BadgeStatus = 'success' | 'error' | 'default' | 'warning' | 'processing';

const props = defineProps<{
  status: string;
}>();

const normalizedStatus = computed(() => `${props.status}`.toLowerCase());

const config = computed<{ status: BadgeStatus; text: string }>(() => {
  switch (normalizedStatus.value) {
    case 'completed':
      return { status: 'success', text: 'Completed' };
    case 'failed':
      return { status: 'error', text: 'Failed' };
    case 'pending':
      return { status: 'default', text: 'Pending' };
    case 'processing':
      return { status: 'processing', text: 'Processing' };
    default:
      return { status: 'default', text: `${props.status}` };
  }
});
</script>

<template>
  <Badge :status="config.status" :text="config.text" />
</template>
